module.exports = __webpack_public_path__ + "static/media/svg_symbol.f9c5c808.svg";